export default __webpack_public_path__ + "static/SR USA - Natural - Declaración-efe87828163b9ee0aa8ea08b7dd442e1.pdf";